/**
 * Document Position Utilities
 * Shared utilities for mapping character positions to document nodes
 */

export interface PositionRange {
  start: number;
  end: number;
  nodeId: string;
}

export function buildPositionMap(nodes: any[]): Map<string, PositionRange> {
  const map = new Map<string, PositionRange>();
  let currentPos = 0;
  
  for (const node of nodes) {
    if (node.type === 'element') {
      const textContent = extractTextFromNode(node);
      const start = currentPos;
      const end = currentPos + textContent.length;
      
      map.set(String(node.id), { start, end, nodeId: String(node.id) });
      currentPos = end;
    }
  }
  
  return map;
}

export function extractTextFromNode(node: any): string {
  if (node.type === 'text') {
    return node.content || '';
  }
  
  if (node.children && Array.isArray(node.children)) {
    return node.children.map(extractTextFromNode).join('');
  }
  
  return '';
}

export function findNodeForPosition(
  position: number,
  positionMap: Map<string, PositionRange>,
  nodes: any[]
): string | null {
  // Find node that contains this position
  for (const [nodeId, range] of positionMap.entries()) {
    if (position >= range.start && position < range.end) {
      return nodeId;
    }
  }
  
  // Fallback: return first paragraph node
  for (const node of nodes) {
    if (node.type === 'element' && node.element === 'paragraph') {
      return String(node.id);
    }
  }
  
  return null;
}

export function findNodesInRange(
  startPos: number,
  endPos: number,
  positionMap: Map<string, PositionRange>
): string[] {
  const nodeIds: string[] = [];
  
  for (const [nodeId, range] of positionMap.entries()) {
    // Check if range overlaps with [startPos, endPos]
    if (range.start < endPos && range.end > startPos) {
      nodeIds.push(nodeId);
    }
  }
  
  return nodeIds;
}



